<template>
  <overview-table
    title="Cortesias - Online"
    :headers="headers"
    :items="items"
    :footers="[footer]"
    collapsable
    @collapse="v => collapsed = v"
  >
    <template #[`item.type`]="{ item }">
      <div>
        {{ item.sector_name }} ({{ item.courtesy_name }})
      </div>
    </template>
    <template #no-data>
      <h4>Ainda não existem cortesias online geradas para este evento.</h4>
    </template>
  </overview-table>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import type Overview from '@/types/Overview'
import OverviewTable from './partials/OverviewTable.vue'

const { overview } = defineProps<{ overview: Overview }>()

const collapsed = ref(false)

// --- Items ---
const items = computed(() => {
  return overview.summary.filter(item => item.origin === 'venda_online' && item.ticket_type_name === 'Cortesia')
})

// --- Header ---
const _headers = ref([
  { key: 'type', value: 'type', title: 'Tipo', sortable: false },
  { key: 'batch', value: 'batch', title: 'Lote', sortable: true },
  { key: 'generated', value: 'generated', title: 'Gerados', sortable: true },
  { key: 'read', value: 'read', title: 'Computados', sortable: true },
])

const headers = computed(() => {
  return _headers.value.map((h) => {
    if (!collapsed.value) return h
    return {
      ...h,
      title: h.key === 'type' || h.key === 'batch' ? '' : h.title,
      sortable: false,
    }
  })
})

// --- Footer ---
const footer = computed(
  () => ({
    type: 'Total',
    generated: items.value.reduce((prev, next) => prev + next.generated, 0),
    read: items.value.reduce((prev, next) => prev + next.read, 0),
  }),
)

</script>
